import React from 'react';
import HeaderComponent from '../WebSite/Header/HeaderComponent';
import FooterComponent from '../WebSite/Footer/FooterComponent';
import SecondaryNavbar from '../SecondaryNavbar/SecondaryNavbar';
import UpdatesBanner from '../UpdatesBanner/UpdatesBanner';
import ClubMainPage from '../Club/ClubMainPage';
import "./SocialMarketplace.css"
import SocialMarketNavbar from '../SocialMarketNavbar/SocialMarketNavbar';

export default function SocialMarketplace() {
  const userTypes= ["FOOD-PROCESSOR", "AssetDeveloper"]

 

  
 
  return (
    <>
    {/* <HeaderComponent/> */}
    <UpdatesBanner 
         className="socialMarketplace text-white"
         bannerText="Buyers looking for organic farming company"
        //  buttonText="Sign up"
        //  href="http://localhost:3001/auth/undefined/signup"
        /> 

<div className='subSectionWrapper'>
    <ClubMainPage type={userTypes}/>
    </div>
           <FooterComponent/>
    </>
  )
}
